import { Actions } from 'vuex-smart-module';
import { Filters } from '@/types';
import { debounce } from '@/utils';
import { EventsCalendarService } from '../services';
import EventsCalendarState from './state';
import EventsCalendarMutations from './mutations';
import EventsCalendarGetters from './getters';
import { EventsCalendar } from '../types';

const eventsCalendarService = new EventsCalendarService();

export default class EventsCalendarActions extends Actions<
  EventsCalendarState,
  EventsCalendarGetters,
  EventsCalendarMutations,
  // eslint-disable-next-line no-use-before-define
  EventsCalendarActions
> {
  private debouncedSearch: (search_text: string) => void;

  constructor() {
    super();
    this.debouncedSearch = debounce(this.search_calendar, 500);
  }

  async get_calendar() {
    const payload: Filters = {
      filters: this.state.filters,
    };
    const { data, code } = await eventsCalendarService.get_calendar(payload);

    if (!Array.isArray(data.items)) {
      this.mutations.SET_EVENTS_CALENDAR([]);
      return;
    }

    const reversed_items = data.items.map((item) => ({
      ...item,
      events: Array.isArray(item.events) ? item.events.reverse() : [],
    }));

    const all_events = reversed_items.flatMap((item) => item.events).map((event) => ({
      id: event.id,
      name: event.title,
      start: event.date,
      slug: event.slug,
      is_expired: event.is_expired,
    }));

    this.mutations.SET_EVENTS_CALENDAR(all_events);
    this.mutations.SET_EVENTS(data.items);

    return code;
  }

  debounce_search_calendar(search_text: string) {
    this.debouncedSearch(search_text);
  }

  async search_calendar(search_text: string) {
    const payload: Filters = {
      filters: {
        search: search_text,
      },
    };

    if (!search_text) {
      this.state.search_events = [];
      return;
    }

    const { data } = await eventsCalendarService.get_calendar(payload);

    if (!Array.isArray(data.items)) {
      this.mutations.SET_EVENTS_CALENDAR([]);
      return;
    }

    const all_events = data.items.flatMap((item) => item.events).map((event) => ({
      id: event.id,
      name: event.title,
      date: event.date,
      date_format: event.date_format,
      slug: event.slug,
      is_expired: event.is_expired,
    }));

    this.mutations.SET_SEARCH_EVENTS(all_events);
  }

  async statistics_sent(event: EventsCalendar.StatisticEvent) {
    await eventsCalendarService.statistics_sent(event);
  }
}
